import { IMAGE_DESKTOP } from '../elements/assets'
import { IMAGE_MOBILE } from '../elements/assets'

export const STATS = `
...on stats_Entry {
  id
  typeHandle

  heading {
    html
  }
  
  statsContent {
    ... on statsContent_Entry {
      title
      id
      
      cards {
        ... on statCard_Entry {
          id
          heading {
            plainText
          }
          backgroundColor
          description

          ${ IMAGE_DESKTOP }

          ${ IMAGE_MOBILE }
        }
      }
    }
  }
}
`